// ── Categorie-filters voor de homepagina (Airbnb-stijl) ───────
// Elke categorie heeft een predicate over (town, concelho). De grid
// toont alleen plaatsen waarvoor predicate true is; "all" toont alles.
export const CATEGORIES = [
  { id: "all",      label: "Alles",      icon: "🧭", match: () => true },
  { id: "coast",    label: "Kust",       icon: "🌊", match: (t) => ["oceaan-kust", "lagune"].includes(t.nature_type) || (t.hardRequirements?.seaDistanceMin ?? 99) <= 20 },
  { id: "mountains",label: "Bergen",     icon: "⛰",  match: (t) => ["bergen", "bossen"].includes(t.nature_type) || ["bergen", "bossen"].includes(t.nature_secondary) },
  { id: "surf",     label: "Surf",       icon: "🏄", match: (t) => (t.scores?.surf ?? 0) >= 3 },
  { id: "farming",  label: "Landbouw",   icon: "🌾", match: (t) => (t.scores?.foodAutonomy ?? 0) >= 3 },
  { id: "schools",  label: "Scholen",    icon: "🏫", match: (t) => (t.nearest_montessori?.km ?? 999) <= 40 },
  { id: "dry",      label: "Droog",      icon: "☀",  match: (t, c) => (c?.climate?.annual_rainfall_mm ?? 9999) <= 700 },
  { id: "lowfire",  label: "Laag brand", icon: "🔥", match: (t, c) => (c?.fire_risk_class ?? 5) <= 2 },
  { id: "wellness", label: "Wellness",   icon: "🧘", match: (t) => (t.scores?.wellness ?? 0) >= 3 },
];

export function filterByCategory(towns, concelhoBySlug, categoryId) {
  const cat = CATEGORIES.find(c => c.id === categoryId) || CATEGORIES[0];
  return towns.filter(t => cat.match(t, concelhoBySlug[t.concelho]));
}
